import { render } from "./AllxAll6OrAll4.vue?vue&type=template&id=f9f5bb40&scoped=true"
import script from "./AllxAll6OrAll4.vue?vue&type=script&lang=js"
export * from "./AllxAll6OrAll4.vue?vue&type=script&lang=js"

import "./AllxAll6OrAll4.vue?vue&type=style&index=0&id=f9f5bb40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9f5bb40"]])

export default __exports__